import { Button } from "baseui/button"
import { useRouter } from "next/router"
import { useAuthentication } from "@today/auth"

type Props = {
  clientName: string
}

function AuthenticationGuard({ clientName }: Props) {
  const router = useRouter()
  const { logout } = useAuthentication()

  return (
    <div className="flex flex-1 flex-col items-center justify-center text-2xl">
      <p className="text-3xl">
        <span className="font-bold">{clientName}</span>님,
      </p>
      <p className="mt-2">이미 가입 및 로그인 된 상태입니다.</p>
      <Button className="mt-12" onClick={() => router.replace("/orders")}>
        주문 페이지로 이동하기
      </Button>
      <Button className="mt-4" kind="secondary" onClick={() => logout()}>
        로그아웃 하기
      </Button>
    </div>
  )
}

export default AuthenticationGuard
